import ErrorHelper from '../helpers/errorHelper';
import {ActionTypes} from '../types/actionTypes';
import {Action} from '../typescript/actionTypes';
import {StoreMaintenanceDetails} from '../typescript/storeTypes';
import {InitialState} from './initialState';

export default function (state: StoreMaintenanceDetails = InitialState.maintenanceDetails, action: Action): StoreMaintenanceDetails {

    switch (action.type) {
        case ActionTypes.MAINTENANCE_DETAILS_SUCCEEDED: {
            return {
                ...state,
                isInMaintenanceMode: action.payload.isInMaintenanceMode,
                maintenanceScheduleStartTime: action.payload.maintenanceScheduleStartTime,
                maintenanceScheduleEndTime: action.payload.maintenanceScheduleEndTime
            };
        }
        case ActionTypes.MAINTENANCE_DETAILS_FAILED: {
            const pattern = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z/g;

            const message = action.payload?.message ?? '';
            const startDateMatch = pattern.exec(message);
            const endDateMatch = startDateMatch === null ? null : pattern.exec(message);

            if(startDateMatch === null || endDateMatch === null) return state;

            return {
                ...state,
                isInMaintenanceMode: true,
                maintenanceScheduleStartTime: startDateMatch[0],
                maintenanceScheduleEndTime: endDateMatch[0],
                isLatestVersion: true
            };
        }
        case ActionTypes.CHECK_VERSION_SUCCEEDED: {
            return {...state, isLatestVersion: action.payload.isLatest};
        }
        case ActionTypes.TIMESHEET_REQUEST_FAILED:
        case ActionTypes.ADD_ENTRY_FAILED:
        case ActionTypes.DELETE_ENTRY_FAILED:
        case ActionTypes.EXPORT_MONTHLY_TIMESHEET_EXCEL_FAILED:
        case ActionTypes.EXPORT_MONTHLY_TIMESHEET_FAILED:
        case ActionTypes.EXPORT_WEEKLY_TIMESHEET_FAILED:
        case ActionTypes.MOST_RECENT_TSCODES_FAILED:
        case ActionTypes.PERMISSIONS_FAILED:
        case ActionTypes.SUPPLIERS_FAILED:
        case ActionTypes.TIMESHEET_COMPLETE_FAILED:
        case ActionTypes.TIMESHEET_INCOMPLETE_FAILED:
        case ActionTypes.TIMESHEETCODE_COMPLETE_FAILED:
        case ActionTypes.TIMESHEETCODE_DELETE_FAILED:
        case ActionTypes.TIMESHEETCODE_INCOMPLETE_FAILED:
        case ActionTypes.SUPPLIERS_EMPLOYEES_FAILED:
        case ActionTypes.TSCODES_FAILED:
        case ActionTypes.UPDATE_ENTRY_FAILED:
        case ActionTypes.USER_FAILED:
        case ActionTypes.VISIBLE_USERS_FAILED:
        case ActionTypes.VISIBLE_SUPPLIERS_FAILED:
        case ActionTypes.ADD_ASSIGNMENT_FAILED: {
            if(ErrorHelper.errorHasStatusCode(action.payload, 503)) {
                return {...state, isInMaintenanceMode: true};
            }

            return state;
        }
        default:
            return state;
    }
}
